module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.20.09.7a452f28.png";